import React, { useState } from 'react'
import { useDispatch, useSelector } from "react-redux";
import { Form, Row, Col, Typography, Alert, message } from 'antd';
import { confirmPasswordRules, passwordRules } from "../../../helpers/helpers";
import { EyeInvisibleOutlined, EyeOutlined } from '@ant-design/icons';
import CustomButton from "../../../components/CustomButton/Button";
import CustomInput from '../../../components/CustomInput/Input';
import { changePassword } from '../../../redux/slices/ProfileSlice';
import CryptoJS from 'crypto-js';
import { BTN_TXT, ERROR_MSGS, TITLE_TXT } from '../../../constants/constants';

const { Title } = Typography;

const ChangePassword = () => {
    const dispatch = useDispatch();
    const { passChangeLoading, passChangeError } = useSelector((state) => state.profile);
    const [visible, setVisible] = useState(false);
    const [isButtonDisabled, setIsButtonDisabled] = useState(true);
    const [form] = Form.useForm();

    const toggleVisibility = () => {
        setVisible(!visible);
    };

    const handleSubmit = async (values) => {
        const hashedOldPassword = CryptoJS.SHA256(values.currentPassword).toString();
        const hashedNewPassword = CryptoJS.SHA256(values.enterPassword).toString();

        const payload = {
            oldPassword: hashedOldPassword,
            newPassword: hashedNewPassword
        }

        const res = await dispatch(changePassword(payload));

        if (res.payload.statusCode === 200) {
            message.success('Password changed successfully! Please login again.', 2);
            form.resetFields();
            localStorage.clear();
            setTimeout(() => {
                window.location.href = "/login";
            }, 2000);
        }
    };

    const handleFieldsChange = () => {
        setIsButtonDisabled(
            !form.isFieldsTouched(true) || form.getFieldsError().some(({ errors }) => errors.length)
        );
    };

    return (
        <div className='investor-details-container'>
            <div className='header-container'>
                <Title level={4}>{TITLE_TXT.CHNG_PWD_TITLE}</Title>
            </div>
            <div className="details-container">
                <Form
                    layout="vertical"
                    onFinish={handleSubmit}
                    form={form}
                    onFieldsChange={handleFieldsChange}
                    initialValues={{ remember: true }}
                    className='change-password-form'
                >
                    <Row>
                        <Col xs={24} md={18} lg={14}>
                            <CustomInput
                                label="Enter Current Password"
                                name="currentPassword"
                                type={visible ? "text" : "password"}
                                isPassword={true}
                                iconRender={(visible) =>
                                    visible ? (
                                        <EyeInvisibleOutlined onClick={toggleVisibility} />
                                    ) : (
                                        <EyeOutlined onClick={toggleVisibility} />
                                    )
                                }
                                placeholder="Current password"
                                rules={[
                                    { required: true, message: ERROR_MSGS.ENTER_CURR_PWD_ERR_MSG },
                                ]}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={24} md={18} lg={14}>
                            <CustomInput
                                label="Enter New Password"
                                name="enterPassword"
                                type={visible ? "text" : "password"}
                                isPassword={true}
                                iconRender={(visible) =>
                                    visible ? (
                                        <EyeInvisibleOutlined onClick={toggleVisibility} />
                                    ) : (
                                        <EyeOutlined onClick={toggleVisibility} />
                                    )
                                }
                                placeholder="Enter Password"
                                rules={passwordRules}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={24} md={18} lg={14}>
                            <CustomInput
                                label="Confirm New Password"
                                name="confirmPassword"
                                type={visible ? "text" : "password"}
                                isPassword={true}
                                iconRender={(visible) =>
                                    visible ? (
                                        <EyeInvisibleOutlined onClick={toggleVisibility} />
                                    ) : (
                                        <EyeOutlined onClick={toggleVisibility} />
                                    )
                                }
                                placeholder="Re-enter Password"
                                rules={confirmPasswordRules}
                            />
                        </Col>
                    </Row>
                    {passChangeError && (
                        <Row>
                            <Col xs={24} md={18} lg={14}>
                                <Alert
                                    style={{ marginBottom: 20 }}
                                    message={passChangeError}
                                    type="error"
                                    showIcon
                                />
                            </Col>
                        </Row>
                    )}
                    <Row>
                        <Col xs={24} md={18} lg={14}>
                            <CustomButton
                                type="primary"
                                htmlType="submit"
                                loading={passChangeLoading}
                                block
                                disabled={isButtonDisabled}
                            >
                                {BTN_TXT.CHNG_PWD}
                            </CustomButton>
                        </Col>
                    </Row>
                </Form>
            </div>
        </div>
    );
};

export default ChangePassword;
